export * from './IngredientCardLabel';
